import { render, staticRenderFns } from "./InvitesMemberForm.vue?vue&type=template&id=37b3ad46"
import script from "./InvitesMemberForm.vue?vue&type=script&lang=js"
export * from "./InvitesMemberForm.vue?vue&type=script&lang=js"
import style0 from "./InvitesMemberForm.vue?vue&type=style&index=0&id=37b3ad46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports